"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrderToApplicationInput = exports.mapPrice = exports.mapDownPayment = exports.mapResidualValue = exports.mapMileage = exports.mapDurationMonths = exports.mapRegistrationFee = exports.mapPreferEmailOverSms = exports.mapUseDebtInsurance = exports.mapTireHotelPerYearFee = exports.mapShouldIncludeFees = exports.mapServiceAgreementPerYearFee = exports.mapR35 = exports.mapDownPaymentSource = exports.mapBeneficialOwnerText = exports.mapBeneficialOwner = exports.mapCoSigner = exports.mapAgreedEndMileage = exports.mapEnovaGrant = exports.mapSubsidizerId = exports.mapExtraEquipmentSubjectToVat = exports.mapPricePerAdditionalMile = exports.mapExternalReference = exports.mapInsuranceCompanyNumber = exports.mapVehicleRegistrationYear = exports.getFirstVehicle = exports.getOfferComments = exports.mapBosCustomerToApplicant = exports.getSsn = exports.getApplicationInputDeleteFields = exports.getLoanApplicationInputDeleteFields = exports.getLeasingApplicationInputDeleteFields = exports.getAmountExVat = void 0;
const enums_1 = require("../../enums");
const fauna_1 = require("./fauna");
const constants_1 = require("../../constants");
const next_1 = require("../next");
const pim_1 = require("./pim");
const pim_2 = require("./pim");
const getAmountExVat = (amountIncVat) => typeof amountIncVat === 'number' ? amountIncVat / 1.25 : amountIncVat;
exports.getAmountExVat = getAmountExVat;
const getLeasingApplicationInputDeleteFields = (customerType) => {
    if (customerType === enums_1.CustomerType.BUSINESS) {
        return [...constants_1.commonLoanMandatoryKeys];
    }
    return [...constants_1.commonLoanMandatoryKeys, ...constants_1.businessMandatoryKeys];
};
exports.getLeasingApplicationInputDeleteFields = getLeasingApplicationInputDeleteFields;
const getLoanApplicationInputDeleteFields = (customerType) => {
    if (customerType === enums_1.CustomerType.BUSINESS) {
        return [...constants_1.commonLeasingMandatoryKeys];
    }
    return [...constants_1.commonLeasingMandatoryKeys, ...constants_1.businessMandatoryKeys];
};
exports.getLoanApplicationInputDeleteFields = getLoanApplicationInputDeleteFields;
const getApplicationInputDeleteFields = (financingType, customerType) => {
    if (financingType === enums_1.FinancingType.LEASING) {
        return (0, exports.getLeasingApplicationInputDeleteFields)(customerType);
    }
    else if (financingType === enums_1.FinancingType.LOAN) {
        return (0, exports.getLoanApplicationInputDeleteFields)(customerType);
    }
};
exports.getApplicationInputDeleteFields = getApplicationInputDeleteFields;
const getSsn = (order) => { var _a; return ((_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.ssn) || null; };
exports.getSsn = getSsn;
const mapBosCustomerToApplicant = (order, customer = null) => {
    const isBusiness = (customer === null || customer === void 0 ? void 0 : customer.customerType) === enums_1.BosCustomerType.BUSINESS;
    return customer
        ? Object.assign(Object.assign({}, (isBusiness
            ? {
                organizationNumber: customer === null || customer === void 0 ? void 0 : customer.organizationNo,
            }
            : {
                ssn: (0, exports.getSsn)(order),
            })), { firstName: customer === null || customer === void 0 ? void 0 : customer.firstName, lastName: customer === null || customer === void 0 ? void 0 : customer.lastName, contacts: {
                email: customer === null || customer === void 0 ? void 0 : customer.email,
                mobilePhone: customer === null || customer === void 0 ? void 0 : customer.phoneMobile,
            } }) : null;
};
exports.mapBosCustomerToApplicant = mapBosCustomerToApplicant;
const getOfferComments = (offer) => {
    var _a;
    return (_a = offer === null || offer === void 0 ? void 0 : offer.comments) === null || _a === void 0 ? void 0 : _a.map((comment) => comment === null || comment === void 0 ? void 0 : comment.text).join('; ');
};
exports.getOfferComments = getOfferComments;
const getFirstVehicle = (order) => { var _a; return ((_a = order === null || order === void 0 ? void 0 : order.chosenOffer) === null || _a === void 0 ? void 0 : _a.vehicles[0]) || (order === null || order === void 0 ? void 0 : order.vehicles[0]); };
exports.getFirstVehicle = getFirstVehicle;
const mapVehicleRegistrationYear = (order) => {
    const vehicle = (0, exports.getFirstVehicle)(order);
    const serialNo = vehicle === null || vehicle === void 0 ? void 0 : vehicle.serialNo;
    return (serialNo === null || serialNo === void 0 ? void 0 : serialNo.length) > 4 ? parseInt(serialNo.substring(0, 4)) || null : null;
};
exports.mapVehicleRegistrationYear = mapVehicleRegistrationYear;
const mapInsuranceCompanyNumber = (order) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = order === null || order === void 0 ? void 0 : order.insurance) === null || _a === void 0 ? void 0 : _a.reference) === null || _b === void 0 ? void 0 : _b.santanderId) !== null && _c !== void 0 ? _c : null;
};
exports.mapInsuranceCompanyNumber = mapInsuranceCompanyNumber;
/**
 * The externalReference field is not to be used, according to Santander developers
 * @param order
 */
const mapExternalReference = (order) => undefined;
exports.mapExternalReference = mapExternalReference;
const mapPricePerAdditionalMile = (offer) => constants_1.priceOverrunLeasingExVat;
exports.mapPricePerAdditionalMile = mapPricePerAdditionalMile;
const mapExtraEquipmentSubjectToVat = (order, vehicleConfig) => (0, pim_2.getAccessoriesIncVatPrice)(order, vehicleConfig);
exports.mapExtraEquipmentSubjectToVat = mapExtraEquipmentSubjectToVat;
const mapSubsidizerId = (offer) => undefined;
exports.mapSubsidizerId = mapSubsidizerId;
const mapEnovaGrant = (offer) => 0;
exports.mapEnovaGrant = mapEnovaGrant;
const mapAgreedEndMileage = (offer) => {
    var _a, _b, _c, _d;
    const durationMonths = (_b = (_a = offer === null || offer === void 0 ? void 0 : offer.financing) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.durationMonths;
    const durationYears = durationMonths ? durationMonths / 12 : null;
    const mileagePerYear = (_d = (_c = offer === null || offer === void 0 ? void 0 : offer.financing) === null || _c === void 0 ? void 0 : _c.request) === null || _d === void 0 ? void 0 : _d.mileage;
    return durationYears && mileagePerYear ? durationYears * mileagePerYear : null;
};
exports.mapAgreedEndMileage = mapAgreedEndMileage;
const mapCoSigner = (order) => undefined;
exports.mapCoSigner = mapCoSigner;
const mapBeneficialOwner = (order) => undefined;
exports.mapBeneficialOwner = mapBeneficialOwner;
const mapBeneficialOwnerText = (order) => undefined;
exports.mapBeneficialOwnerText = mapBeneficialOwnerText;
const mapDownPaymentSource = (order) => undefined;
exports.mapDownPaymentSource = mapDownPaymentSource;
const mapR35 = (order) => undefined;
exports.mapR35 = mapR35;
const mapServiceAgreementPerYearFee = (order) => undefined;
exports.mapServiceAgreementPerYearFee = mapServiceAgreementPerYearFee;
const mapShouldIncludeFees = (order) => false;
exports.mapShouldIncludeFees = mapShouldIncludeFees;
const mapTireHotelPerYearFee = (order) => undefined;
exports.mapTireHotelPerYearFee = mapTireHotelPerYearFee;
const mapUseDebtInsurance = (order) => undefined;
exports.mapUseDebtInsurance = mapUseDebtInsurance;
const mapPreferEmailOverSms = (order) => undefined;
exports.mapPreferEmailOverSms = mapPreferEmailOverSms;
/**
 * Norwegian name: engangsavgift
 * Fastsatt beløp uten mva.
 * @param offer
 * @param vehicleConfig
 */
const mapRegistrationFee = (offer = null, vehicleConfig = null) => {
    var _a, _b;
    const configValue = (_a = vehicleConfig === null || vehicleConfig === void 0 ? void 0 : vehicleConfig.pricing) === null || _a === void 0 ? void 0 : _a.vehicleRoadTax;
    return ((_b = offer === null || offer === void 0 ? void 0 : offer.financing) === null || _b === void 0 ? void 0 : _b.registrationFee) || configValue;
};
exports.mapRegistrationFee = mapRegistrationFee;
const mapDurationMonths = (order) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = order === null || order === void 0 ? void 0 : order.chosenOffer) === null || _a === void 0 ? void 0 : _a.financing) === null || _b === void 0 ? void 0 : _b.request) === null || _c === void 0 ? void 0 : _c.durationMonths;
};
exports.mapDurationMonths = mapDurationMonths;
const mapMileage = (order) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = order === null || order === void 0 ? void 0 : order.chosenOffer) === null || _a === void 0 ? void 0 : _a.financing) === null || _b === void 0 ? void 0 : _b.request) === null || _c === void 0 ? void 0 : _c.mileage) !== null && _d !== void 0 ? _d : 0;
};
exports.mapMileage = mapMileage;
/**
 * Norwegian name: restverdi
 * Fastsatt beløp uten mva.
 * @param order
 * @param vehicleConfig
 */
const mapResidualValue = (order, vehicleConfig = null) => {
    var _a, _b, _c;
    const durationMonths = (0, exports.mapDurationMonths)(order);
    const mileage = (0, exports.mapMileage)(order);
    const configValue = pim_1.PimMapper.getResidualValue(vehicleConfig, durationMonths, mileage);
    return ((_c = (_b = (_a = order === null || order === void 0 ? void 0 : order.chosenOffer) === null || _a === void 0 ? void 0 : _a.financing) === null || _b === void 0 ? void 0 : _b.request) === null || _c === void 0 ? void 0 : _c.residualValue) || configValue;
};
exports.mapResidualValue = mapResidualValue;
/**
 * Norwegian name: egenkapital (if Loan), startleie (if Leasing)
 * Næringskunder betaler også mva. på startleie / egenkapital
 * @param offer: ICalculation
 * @param vehicleConfig: IVehicleConfiguration
 */
const mapDownPayment = (offer, vehicleConfig = null) => {
    var _a, _b, _c;
    const isElectric = (0, next_1.isElectricVehicle)(vehicleConfig);
    const downPayment = ((_a = offer === null || offer === void 0 ? void 0 : offer.financing) === null || _a === void 0 ? void 0 : _a.downPayment) || ((_c = (_b = offer === null || offer === void 0 ? void 0 : offer.financing) === null || _b === void 0 ? void 0 : _b.request) === null || _c === void 0 ? void 0 : _c.downPayment);
    return isElectric ? downPayment : (0, exports.getAmountExVat)(downPayment);
};
exports.mapDownPayment = mapDownPayment;
/**
 *
 * ToDo: what about ExtraEquipmentSubjectToVat?
 * @param offer
 */
const mapPrice = (offer) => {
    var _a, _b;
    return (_b = (_a = offer === null || offer === void 0 ? void 0 : offer.financing) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.investedAmount;
};
exports.mapPrice = mapPrice;
const mapOrderToApplicationInput = (order, customer = null, vehicleConfig = null) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!order || !(order === null || order === void 0 ? void 0 : order.chosenOffer))
        return null;
    const offer = order === null || order === void 0 ? void 0 : order.chosenOffer;
    const financing = offer === null || offer === void 0 ? void 0 : offer.financing;
    const request = financing === null || financing === void 0 ? void 0 : financing.request;
    const financingType = offer === null || offer === void 0 ? void 0 : offer.financingType;
    const customerType = ((_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.customerType) || enums_1.CustomerType.PRIVATE;
    const deleteKeys = (0, exports.getApplicationInputDeleteFields)(financingType, customerType);
    if (!request)
        return null;
    const fullName = `${(_b = order === null || order === void 0 ? void 0 : order.user) === null || _b === void 0 ? void 0 : _b.firstName} ${(_c = order === null || order === void 0 ? void 0 : order.user) === null || _c === void 0 ? void 0 : _c.lastName}` || null;
    const salesPerson = {
        fullName,
        id: (_f = (_e = (_d = order === null || order === void 0 ? void 0 : order.user) === null || _d === void 0 ? void 0 : _d.reference) === null || _e === void 0 ? void 0 : _e.santanderId) !== null && _f !== void 0 ? _f : null,
        username: (_g = order === null || order === void 0 ? void 0 : order.user) === null || _g === void 0 ? void 0 : _g.email,
    };
    const applicant = (0, exports.mapBosCustomerToApplicant)(order, customer);
    const commonInput = {
        agreementCode: request === null || request === void 0 ? void 0 : request.agreementCode,
        applicant,
        customerType,
        downPayment: (0, exports.mapDownPayment)(offer, vehicleConfig),
        duration: request === null || request === void 0 ? void 0 : request.durationMonths,
        financingType,
        groupCode: (_h = parseInt(request === null || request === void 0 ? void 0 : request.objectGroupCode)) !== null && _h !== void 0 ? _h : 0,
        ignoreCampaigns: financing === null || financing === void 0 ? void 0 : financing.ignoreCampaigns,
        insuranceCompanyNumber: (0, exports.mapInsuranceCompanyNumber)(order),
        make: ((_j = vehicleConfig === null || vehicleConfig === void 0 ? void 0 : vehicleConfig.model) === null || _j === void 0 ? void 0 : _j.make) ? (0, enums_1.getMakeNameByCode)(vehicleConfig.model.make, true) : request === null || request === void 0 ? void 0 : request.objectMake,
        manualNominalInterest: (request === null || request === void 0 ? void 0 : request.manualNominalInterest) || null,
        model: ((_k = vehicleConfig === null || vehicleConfig === void 0 ? void 0 : vehicleConfig.model) === null || _k === void 0 ? void 0 : _k.series) || (request === null || request === void 0 ? void 0 : request.objectModel),
        price: (0, exports.mapPrice)(offer),
        registrationYear: (0, exports.mapVehicleRegistrationYear)(order),
        salesPerson,
    };
    const loanInput = {
        coSigner: (0, exports.mapCoSigner)(order),
        manualAdministrationFee: (request === null || request === void 0 ? void 0 : request.manualAdministrationFee) || null,
    };
    const leasingInput = {
        agreedEndMileage: (0, exports.mapAgreedEndMileage)(offer),
        enovaGrant: (0, exports.mapEnovaGrant)(offer),
        extraEquipmentSubjectToVat: (0, exports.mapExtraEquipmentSubjectToVat)(order, vehicleConfig),
        pricePerAdditionalMile: (0, exports.mapPricePerAdditionalMile)(offer),
        registrationFee: (0, exports.mapRegistrationFee)(offer, vehicleConfig),
        residualValue: (0, exports.mapResidualValue)(order, vehicleConfig),
        yearlyMileage: (0, exports.mapMileage)(order),
    };
    const optionalFields = {
        beneficialOwner: (0, exports.mapBeneficialOwner)(order),
        beneficialOwnerText: (0, exports.mapBeneficialOwnerText)(order),
        downPaymentSource: (0, exports.mapDownPaymentSource)(order),
        externalReference: (0, exports.mapExternalReference)(order),
        note: (0, exports.getOfferComments)(offer),
        preferEmailOverSms: (0, exports.mapPreferEmailOverSms)(order),
        r35: (0, exports.mapR35)(order),
        serviceAgreementPerYearFee: (0, exports.mapServiceAgreementPerYearFee)(order),
        shouldIncludeFees: (0, exports.mapShouldIncludeFees)(order),
        subsidizerId: (0, exports.mapSubsidizerId)(offer),
        tireHotelPerYearFee: (0, exports.mapTireHotelPerYearFee)(order),
        useDebtInsurance: (0, exports.mapUseDebtInsurance)(order),
    };
    const input = Object.assign(Object.assign(Object.assign({}, commonInput), optionalFields), (financingType === enums_1.FinancingType.LOAN ? loanInput : leasingInput));
    return fauna_1.FaunaMapper.deleteFields(input, deleteKeys);
};
exports.mapOrderToApplicationInput = mapOrderToApplicationInput;
//# sourceMappingURL=scb-application.js.map